<template>
    <a-spin :spinning="spinning" tip="Loading...">
        <div class="card mb-3">
            <div class="row no-gutters">
                <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                    <div class="card-body">
                        
                        <!-- <div class="row">
                            <div class="col-md-4">
                                <base-input alternative="" label="Date"><br>
                                    <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM-DD-YYYY hh:mm A" :placeholder="['Start Date', 'End Date']" style="width:100%"/>
                                </base-input>
                            </div>
                        </div> -->
    
                        <div class="row">
                            <div class="col-md-4">
                                <base-input alternative="" label="Select User">
                                    <a-select mode="multiple" v-model="inputUser" showSearch placeholder="All Users" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                        <a-select-option v-for="option in userOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                    </a-select>
                                </base-input>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4">
                                <base-input alternative="" label="Select User Group">
                                    <a-select mode="multiple" v-model="inputUserGroup" showSearch placeholder="All User Groups" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                        <a-select-option v-for="option in userGroupOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                    </a-select>
                                </base-input>
                            </div>
                        </div>
    
                        <!-- <div class="row">
                            <div class="col-md-4">
                                <base-input label="Sort By" >
                                    <select class="form-control" size="large" v-model="inputSortBy">
                                        <option v-for="option in sortOptions" v-bind:value="option.key" v-bind:key="option.key">
                                            {{ option.value }}
                                        </option>
                                    </select>
                                </base-input>
                            </div>
                            <div class="col-md-2 mt-3 pt-3">
                                <button type="button" class="btn btn-sm btn-link" @click='showSortInfoDiv' >
                                    {{showSortInfo == 'asc' ? 'Ascending (A-Z) ↡' : 'Descending (Z-A) ↟'}}
                                </button>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4">
                                <base-input label="Status" >
                                    <select class="form-control" size="large" v-model="inputStatus">
                                        <option v-for="option in statusOptions" v-bind:value="option.key" v-bind:key="option.key">
                                            {{ option.value }}
                                        </option>
                                    </select>
                                </base-input>
                            </div>
                        </div> -->
    
                        <!-- <base-checkbox class="mb-3" v-model="isShowAddress">
                            Show Address
                        </base-checkbox> -->
                        
                        <div class="row">
                            <div class="col-md-12">
                                <br>
                                <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                                <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
    
                                <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                    <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="JsonData = []"> Download CSV </button> &nbsp; &nbsp;
                                </vue-json-to-csv>
                                <button v-if="JsonData.length > 0" class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateExcel"> Download excel </button> &nbsp; &nbsp;
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </a-spin>
    </template>
    
    <script>
        import HTTPRequest from '../../controllers/httpRequest.js'
        import secureStorage from '../../controllers/secureStorage';
        import AdvanceFilter from '../Bir Reports/ReportAdvanceFilter'
        import reportUtils from '../../components/reportUtils'
        import moment from 'moment';
        import jsPDF from 'jspdf';
        import 'jspdf-autotable';
        import VueJsonToCsv from 'vue-json-to-csv';
        import * as ExcelJS from "exceljs";
        import { saveAs } from "file-saver";
    
        import {
            mapState,
            mapActions
        } from 'vuex'
    
        var component_x;
    
        export default {
            components: {
                AdvanceFilter,VueJsonToCsv
            },
            data() {
                return {
                    spinning: false,
                    inputDate: [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
                    inputUser: [],
                    inputUserGroup: [],
                    site_type: "ho",
                    userOptions: [],
                    userGroupOptions: [],
                    inputLocation: [],
                    locationOptions: [],
                    headerExcelInfo: "",
                    // locationPath: [],
                    inputStatus: '',
                    statusOptions: [
                        {key: 'A', value: 'Activated'},
                        {key: 'D', value: 'Deactivated'},
                        {key: '', value: 'All'},
                    ],
                    inputSortBy: 'code',
                    sortOptions: [
                        {key: 'code', value: 'Customer Code'},
                        {key: 'name', value: 'Address'},
                    ],
                    currDate: moment().format("L_LT").split(":").join(";"),
                    isShowAddress: false,
                    isShowDetail: true,
                    inputFrom: moment().startOf('month'),
                    inputTo: moment().endOf('month'),
                    monthFormat: 'MM/YYYY',
                    birDateReports: [],
                    toggleAdvanceFilter: false,
                    toggleLabel: "Advanced Filter",
                    advancedFilterParams: {},
                    params: {},
                    advancedFilterVisible: true,
    
                    showSortInfo: 'asc',
                    JsonData: []
                }
            },
            mounted: async function () {
                component_x = this;
    
                var userId = secureStorage.getItem("userId")
                var users = await HTTPRequest.getRequest(component_x.endPoint + "users/get_valid_users", null);
                component_x.userOptions = users;
                component_x.sort(component_x.userOptions);

                var user_groups = await HTTPRequest.getRequest(component_x.endPoint + "user_groups/get_valid_user_groups", null);
                component_x.userGroupOptions = user_groups;
                component_x.sort(component_x.userGroupOptions);
    
    
                let siteId = secureStorage.getItem("defaultSiteId")
                this.inputUser = []
                this.inputUserGroup = []
                
    
                let site = await HTTPRequest.getRequest(this.endPoint + "/users/" + siteId, null)
                if(site != undefined){
                    this.site_type = site.site_type
                }
            },
            computed: {
                ...mapState(['currentProfile', 'endPoint']),
            },
            methods: {
                moment,
                filterOption(input, option) {
                    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                },
                // Advanced Info
                showSortInfoDiv(){
                    this.showSortInfo == 'asc' ? this.showSortInfo = 'desc' : this.showSortInfo = 'asc'
                },
                autoChange(e){
                    if(e.target.value == ''){
                        this.isShowDetail = true
                    }
                },
                convertToCurrency(num){
                    return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                },
                sort(data){
                    data.sort(function (a, b) {
                        return a.name.localeCompare(b.name);
                    });
                },
                changeParams(params, actualParams, mode){
                    this.params = params
                    this.advancedFilterParams = actualParams
    
                    if(mode == 'filter'){
                        this.advanceFilter(false);
                    }
                },
                generateReport: async function () {
                    this.spinning = true;
                    let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                    // let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                    // console.log(filter_header,additional_params,status_header, this.inputUser, this.userOptions.filter(x => this.inputUser.includes(x.id)).map(x => x.name))
                    let filter_header = ''
                    let filter_header_ug = ''
                    //filter_header = filter_header.concat("Status: ", this.statusOptions.find(x => x.key === this.inputStatus).value)
                    if(this.inputUser != undefined && this.inputUser.length > 0 && this.inputUser != []){
                         let users = this.userOptions.filter(x => this.inputUser.includes(x.id)).map(x => x.name)
                         filter_header = filter_header.concat("Users: ", users )
                    }else{
                        let users = this.userOptions.map(x => x.name)
                        filter_header = filter_header.concat("Users: All Users")
                    }

                    if(this.inputUserGroup != undefined && this.inputUserGroup.length > 0 && this.inputUserGroup != []){
                         let user_groups = this.userGroupOptions.filter(x => this.inputUserGroup.includes(x.id)).map(x => x.name)
                         filter_header_ug = filter_header_ug.concat("User Groups: ", user_groups )
                    }else{
                        let user_groups = this.userGroupOptions.map(x => x.name)
                        filter_header_ug = filter_header_ug.concat("User Groups: All User Groups")
                    }

                    let filteredOptions = ''
                    let sort = 'Descending'
                    if(this.showSortInfo == 'asc'){
                        sort ='Ascending'
                    }
                    filteredOptions = filteredOptions.concat('Filtered by: ',filter_header,' | ',filter_header_ug,' ')
                
                    let parameters = {
                        "user_id": this.inputUser.toString(),
                        "user_group_id": this.inputUserGroup.toString()
                    }
    
                    var get_request = await HTTPRequest.getRequest(this.endPoint + 'user_access_reports?', parameters);
                                  
                    if(get_request.error) {
                        reportUtils.openNotificationWithIcon(component_x,'error', get_request.error);
                        return
                    }
                    var userspecific = get_request;
                
                    let design_x = 0
                    let design_y = 0


                    // -- rank,product_id , product_name,sales, transaction_count,qty_sold,onhand 
                    if(userspecific.length > 0){
                        var doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });

                        // let reportLogo = document.getElementById('reportLogo');
                        // doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                        let headers = [];
                        
                        headers = [
                            [
                                {content: 'Name', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'User Name', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Email', styles: {halign: 'center', valign: 'auto'}},
                                // {content: 'HCM ID', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Account Owner', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Expiration Date', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Status', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Created At', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Updated At', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'User Groups', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Site Access', styles: {halign: 'center', valign: 'auto'}},
                                {content: 'Brand Access', styles: {halign: 'center', valign: 'auto'}}
                            ]
                        ]

                        for(let x=0; x < userspecific.length; x++){
                            this.adminGroups = userspecific[x].report_details

                            if(x > 0 && this.adminGroups.length > 0){
                                doc.addPage();
                            }

                            let reportData = [];

                            if(this.adminGroups.length > 0){

                                for(let i=0; i < this.adminGroups.length; i++){
                                    let reportLine = this.adminGroups[i]
                                    // let basketSize = this.convertToCurrency(Number(reportLine.sales/reportLine.transaction_count))

                                    let detail = []
                                    
                                        detail = [
                                            reportLine.name,
                                            reportLine.user_name,
                                            reportLine.email,
                                            // reportLine.hcm,
                                            reportLine.is_account_owner,
                                            (reportLine.expired_at == null) ? '-' : moment(reportLine.expired_at).format('YYYY-MM-DD hh:mm a'),
                                            reportLine.status,
                                            moment(reportLine.created_at).format('YYYY-MM-DD hh:mm a'),
                                            moment(reportLine.updated_at).format('YYYY-MM-DD hh:mm a'),
                                            reportLine.user_groups,
                                            reportLine.user_sites,
                                            reportLine.user_brands
                                        ]
                                    reportData.push(Object.assign({}, detail))

                                }
                            }


                            design_x = 330
                            design_y = 200
                            
                            doc.setFontSize(14);
                            doc.setFontType("bold");
                            doc.text(15,20,"User Access Reports")
                            doc.setFontType("normal");
                            doc.setFontSize(10);
                            //doc.text(15,25,"For the Period of " + from_header + " to " + to_header)
                            doc.text(15,30,filteredOptions )

                            let splitTitle = doc.splitTextToSize("Filtered by: " + filter_header, 180);
                            //doc.text(15,35,splitTitle);

                            let colStyles = {}

                            colStyles = {
                                0: {cellWidth: 25,halign: 'left'},
                                1: {cellWidth: 25,halign: 'left'},
                                2: {cellWidth: 25,halign: 'left'},
                                3: {cellWidth: 25,halign: 'center'},
                                4: {cellWidth: 25,halign: 'center'},
                                5: {cellWidth: 25,halign: 'center'},
                                6: {cellWidth: 25,halign: 'center'},
                                7: {cellWidth: 25,halign: 'center'},
                                8: {cellWidth: 45,halign: 'left'},
                                9: {cellWidth: 45,halign: 'left'},
                                10: {cellWidth: 45,halign: 'left'}
                            }


                            doc.autoTable({
                                startY: 35,
                                head: headers,
                                body: reportData,
                                theme: 'plain',
                                tableWidth: 'auto',
                                headStyles: {
                                    lineWidth: 0.15,
                                    cellPadding: 5
                                },
                                margin: { bottom: 30 },
                                styles: {
                                    cellPadding: 1.3, fontSize: 10,
                                },
                                columnStyles: colStyles,
                                didParseCell: function(data) {
                                    if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                        data.cell.styles.fillColor = [0, 0, 0]
                                        data.cell.styles.fontSize = 1
                                        data.cell.styles.cellPadding = 0
                                    } else if (data.row.section == 'body' && (data.row.raw[0] == 'Grand Total :' || data.row.raw[3] == 'Grand Total :')){
                                        data.cell.styles.fontStyle = 'bold'
                                    }
                                }
                            });


                        }
                        // end loop

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        let pageCount = doc.internal.getNumberOfPages();
                        
                        for(let i = 1; i <= pageCount; i++) {
                            doc.setPage(i);
                            reportUtils.pdfTools.addFooter(doc, printed_by, "User Access Report", design_x, design_y, i, pageCount)
                        }
                        // await window.open(URL.createObjectURL(doc.output("blob")))
                        doc.save(`UserAccessReport_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                    } else {
                        reportUtils.openNotificationWithIcon(component_x,'warning', 'Try increasing the scope by adjusting the filters.');
                    }
                    this.spinning = false;
                },
                getBase64Image(url) {
                    const img = new Image();
                    img.setAttribute('crossOrigin', 'anonymous');
                    img.onload = () => {
                        const canvas = document.createElement("canvas");
                        canvas.width = img.width;
                        canvas.height = img.height;
                        const ctx = canvas.getContext("2d");
                        ctx.drawImage(img, 0, 0);
                        const dataURL = canvas.toDataURL("image/png");
                        console.log(dataURL)
                    }
                    return img.src = url
                },
                async generateExcel(){
                    const workbook = new ExcelJS.Workbook();
                    workbook.created = new Date();
                    workbook.modified = new Date();
                    const sheet = workbook.addWorksheet("User Access Report", {
                        pageSetup:{paperSize: 9}
                    });
    
                    let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                    // let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                    let filter_header = ''
                    filter_header = filter_header.concat("Status: ", this.statusOptions.find(x => x.key === this.inputStatus).value)
                    // if(this.inputUser != undefined && this.inputUser.length > 0 && this.inputUser != []){
                    //     let users = this.userOptions.filter(x => this.inputUser.includes(x.id)).map(x => x.name)
                    //     filter_header = filter_header.concat("users: ", users )
                    // }else{
                    //     let users = this.userOptions.map(x => x.name)
                    //     filter_header = filter_header.concat("users: All users")
                    // }

                    let filteredOptions = ''
                    let sort = 'Descending'
                    if(this.showSortInfo == 'asc'){
                        sort ='Ascending'
                    }
                    filteredOptions = filteredOptions.concat('Ordered By: ',_.startCase(this.inputSortBy),' ', sort)
                    
                    const data_starts_at_row = 8
    
                    // let reportLogo = document.getElementById('reportLogo');
                
                    // const base64Image = reportUtils.csvxlsxTools.getBase64Image(reportLogo)
    
                    // const imageId2 = workbook.addImage({
                    //     base64: base64Image,
                    //     extension: 'png',
                    // });
    
                    // sheet.addImage(imageId2, {
                    //     tl: { col: 0, row: 0 },
                    //     ext: { width: 61, height: 61 }
                    // });
    
                    sheet.getRow(4).values = [`User Access Report`]
                    // sheet.getRow(5).values = [`For the Period of ${from_header} to ${to_header}`]
                    // sheet.getRow(6).values = [`Filtered by: ${filter_header}}`]
                    sheet.getRow(7).values = [`${filteredOptions}`]
                    
                    
                        sheet.getRow(data_starts_at_row).values =[
                            "Name",
                            "User Name",
                            "Email",
                            "HCM ID",
                            "Account Owner",
                            "Expiration Date",
                            "Status",
                            "Created At",
                            "Updated At",
                            "User Groups",
                            "Site Access",
                            "Brand Access"
                        ];
                        sheet.columns = [
                            { key: "name" , width: 10 },
                            { key: "user_name" , width: 10 },
                            { key: "email", width: 20 },
                            { key: "hcm", width: 20 },
                            { key: "is_account_owner" , width: 30 },
                            { key: "expired_at", width: 15 },
                            { key: "status", width: 30 },
                            { key: "created_at", width: 20 },
                            { key: "updated_at", width: 20 },
                            { key: "user_groups", width: 20 },
                            { key: "user_sites", width: 20 },
                            { key: "user_brands", width: 20 }
                        ];

                    var report_details = this.JsonData
                    // var report_details = get_request[0].report_details
                    // console.log("details", report_details)
                    // console.log(this.JsonData)
                    var rowDatas = []
                    var horizontal_range = 0

                    for(let i = 0; i < report_details.length; i++){
                        const report_detail = report_details[i]
                        // console.log("report details: ", report_details);
                        if(report_detail){
                            let rowData = {
                                name: report_detail["Name"],
                                user_name: report_detail["User Name"],
                                email: report_detail["Email"],
                                hcm: report_detail["HCM ID"],
                                is_account_owner: report_detail["Account Owner"],
                                expired_at: report_detail["Expiration Date"],
                                status: report_detail["Status"], 
                                created_at: report_detail["Created At"],
                                updated_at: report_detail["Updated At"],
                                user_groups: report_detail["User Groups"],
                                user_sites: report_detail["Site Access"],
                                user_brands: report_detail["Brand Access"]
                            }
                            if(this.isShowAddress == false){
                                rowData =
                                {
                                    name: report_detail["Name"],
                                    user_name: report_detail["User Name"],
                                    email: report_detail["Email"],
                                    hcm: report_detail["HCM ID"],
                                    is_account_owner: report_detail["Account Owner"],
                                    expired_at: report_detail["Expiration Date"],
                                    status: report_detail["Status"], 
                                    created_at: report_detail["Created At"],
                                    updated_at: report_detail["Updated At"],
                                    user_groups: report_detail["User Groups"],
                                    user_sites: report_detail["Site Access"],
                                    user_brands: report_detail["Brand Access"]
                                }
                        }
                        rowDatas.push(rowData)

                        // console.log("row data: ", rowData);
                        // console.log("report detail: ", report_detail);

                        }

                    }
    
                    sheet.addRows(rowDatas);
    
                    //styles
                    sheet.getRow(4).font = { bold: true, size: 16 };
                    sheet.getRow(4).height = 20;
                    // sheet.getRow(7).font = { bold: true };
                    sheet.getRow(data_starts_at_row).font = { bold: true };
    
                    // sheet.getRow(data_starts_at_row).eachCell({ includeEmpty: true }, function(cell) {
                    //     sheet.getCell(cell.address).fill = { type: 'pattern', pattern: 'darkVertical', fgColor: { argb: '89CFF0'}}
                    // })
    
                    sheet.eachRow(function (Row, rowNum) {
                        if(rowNum >= data_starts_at_row){
                            Row.eachCell(function (Cell, cellNum) {
                                if (rowNum == data_starts_at_row) {
                                    Cell.alignment = {
                                        horizontal: 'center'
                                    }
                                }
                                else{
                                    Cell.alignment = {
                                        vertical: 'middle',
                                        horizontal: 'left'
                                    }
                                }
                            })
                        }
                    })
                    
                    workbook.xlsx.writeBuffer().then(function(buffer) {
                        const blob = new Blob([buffer], { type: "applicationi/xlsx" });
                        saveAs(blob, `UserAccessReport.xlsx`);
                    });
                    this.JsonData = []
                },
                generateFile: async function() {
                    this.spinning = true;
                    let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                    // let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                    let filter_header = ''

                    if(this.inputUser != undefined && this.inputUser.length > 0 && this.inputUser != []){
                        let users = this.userOptions.filter(x => this.inputUser.includes(x.id)).map(x => x.name)
                        filter_header = filter_header.concat("users: ", users )
                    }else{
                        let users = this.userOptions.map(x => x.name)
                        filter_header = filter_header.concat("users: All users")
                    }

                    let filteredOptions = ''
                    let sort = 'Descending'
                    if(this.showSortInfo == 'asc'){
                        sort ='Ascending'
                    }
                    filteredOptions = filteredOptions.concat('Ordered By: ',_.startCase(this.inputSortBy),' ', sort)
                    
                    if(this.inputLimit != '' && this.inputLimit != null){
                        filteredOptions = filteredOptions.concat(' ,Top: ',this.inputLimit)
                    } 


                    let parameters = {
                        "user_id": this.inputUser.toString(),
                        "user_group_id": this.inputUserGroup.toString(),
                    }
    
                    var get_request = await HTTPRequest.getRequest(this.endPoint + 'user_access_reports?', parameters);
                                  
                    if(get_request.error) {
                        reportUtils.openNotificationWithIcon(component_x,'error', get_request.error);
                        return
                    }

                    if(get_request.length > 0){
                        let userspecific = get_request;
                        let headers = [
                            "Name",
                            "User Name",
                            "Email",
                            "HCM ID",
                            "Account Owner",
                            "Expiration Date",
                            "Status",
                            "Created At",
                            "Updated At",
                            "User Groups",
                            "Site Access",
                            "Brand Access"
                        ];
                        
                        let site_specific = [];
    
                        for(let x=0; x < userspecific.length; x++){
                            this.adminGroups = userspecific[x].report_details
    
                            let reportData = [];
                            if(x > 0){
                                // Add second set of headers
                                reportData.push(headers)
                            }
                            if(this.adminGroups.length > 0){
                                console.log(this.adminGroups.length)
                                let grouper = 'start'
                                for(let i=0; i < this.adminGroups.length; i++){
                                    let reportLine =this.adminGroups[i]
                                    let detail = []
                                    
                                        detail = [
                                            reportLine.name,
                                            reportLine.user_name,
                                            reportLine.email,
                                            reportLine.hcm,
                                            reportLine.is_account_owner,
                                            (reportLine.expired_at == null) ? '-' : moment(reportLine.expired_at).format('YYYY-MM-DD hh:mm a'),
                                            reportLine.status,
                                            moment(reportLine.created_at).format('YYYY-MM-DD hh:mm a'),
                                            moment(reportLine.updated_at).format('YYYY-MM-DD hh:mm a'),
                                            reportLine.user_groups,
                                            reportLine.user_sites,
                                            reportLine.user_brands
                                        ]
                                    reportData.push(Object.assign({}, detail))
                                }
    
                            }
    
                            let printed_by = secureStorage.getItem("email")
                            if(printed_by == null){
                                printed_by = ''
                            }
    
                            // reportData.push(["User Access Report" + "Generated By: " + printed_by,"For the Period of " + from_header + " to " + to_header])

                            let keys = headers;
                            let values = reportData;
                            var values_length = values.length;
    
                            let newJsonData=[];
    
                            // change headers and report data as key and value object
                            for(var i=0;i < values_length; i++){
                                var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                                    [val]: values[i][index]
                                      }
                                  )
                                )
                              );
                              newJsonData.push(result)
                            }
    
                            // change undefined on arr
                            newJsonData.forEach(function(obj) {
                              for(var i in obj) {
                                if(obj[i] === undefined || obj[i] === null ) {
                                  obj[i] = '';
                                }
                              }
                            });
                            site_specific.push(newJsonData)
                        }
                        // for each site specific[] convert nested to single array
                        this.JsonData = site_specific.flat(Infinity);
                    } else {
                        reportUtils.openNotificationWithIcon(component_x, 'warning', 'No Data.');
                    }
                    this.spinning = false;
                },
                clearJsonData(){
                 this.JsonData = [];
                },
            }
        };
    </script>
    
    <style></style>
